/*
 * One-time Chart.js component registration. Imported by every chart
 * wrapper so registration is idempotent regardless of which chart loads
 * first.
 */
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { SankeyController, Flow } from "chartjs-chart-sankey";

let registered = false;
export function registerCharts() {
  if (registered) return;
  ChartJS.register(
    ArcElement,
    BarElement,
    CategoryScale,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Tooltip,
    SankeyController,
    Flow,
  );
  registered = true;
}
